import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { getApiRoute } from "src/services";

async function trackCriticalAnalyticsEvent({
  eventName,
  clientId,
  sessionId,
  customParams,
}) {
  await axios.post(
    getApiRoute("analytics", "CRITICAL_EVENT"),
    {
      eventName,
      ...(clientId ? { clientId } : {}),
      ...(sessionId ? { sessionId } : {}),
      customParams,
    },
    { withCredentials: true },
  );
}

export function useTrackCriticalAnalyticsEvent() {
  return useMutation({ mutationFn: trackCriticalAnalyticsEvent });
}
